export const HttpConstants = {
  headers: {
    ACCEPT_LANGUAGE: 'Accept-Language',
    CLIENT_APPLICATION: 'Edutrackr-Client-Application',
  },
};
